import { useI18n, Trans } from '~/common/context';
import { Flex, Select, Text } from '@wyz/ui';
import { PurchaseSearchHelpers } from '~/purchase/helpers';
import { IProductListState, IProductSort } from '~/purchase/types';
import { memo } from 'react';

type Props = {
  value: IProductListState['sort'];
  onChange: (selected: IProductSort | undefined) => void;
};
const SortField = ({ value, onChange }: Props) => {
  const { t } = useI18n();

  const SORT_OPTIONS = [
    {
      label: t('app.purchase.search_page.filter.sort.relevance'),
      value: PurchaseSearchHelpers.DEFAULT_SEARCH_SORT,
    },
    {
      label: t('app.purchase.search_page.filter.sort.price'),
      value: 'price',
    },
    {
      label: t('app.common.estimation_delivery'),
      value: 'estimatedDelivery',
    },
  ];
  const defaultSort = SORT_OPTIONS.find((item) => item.value === value);

  return (
    <Flex alignItems='center' className='space-x-2'>
      <Text color='secondary-gray' heading='xs'>
        <Trans i18nKey='app.purchase.search_page.filter.sort.label' />
      </Text>
      <Select<false>
        name='sort'
        placeholder={
          <Trans i18nKey='app.purchase.search_page.filter.sort.default' />
        }
        className='sorter-select'
        defaultValue={defaultSort}
        onChange={(selected) => {
          onChange(selected?.value as IProductSort | undefined);
        }}
        options={SORT_OPTIONS}
        size='sm'
      />
    </Flex>
  );
};

export default memo(SortField);
